import { FilterTypeKey, FilterType, INumberFilter, IStringFilter, IEnumFilter, IEntityFilter } from '../../components/filters-menu/filters';
import { performanceFilters } from '../../components/filters-menu/filters/perfomance.filter';
import { Statuses } from '../../enums/status';
import { CampaignsInputOptionsApi } from '../../apis/campaign-input-options.api';

export const dealFilters = new Map<FilterTypeKey, FilterType>([
	[
		'numberFilters',
		{
			...performanceFilters.numberFilters,
			deal_cpm: { columnName: 'Deal CPM', cellKey: 'deal_cpm' },
		} as INumberFilter,
	],
	[
		'stringFilters',
		{
			...performanceFilters.stringFilters,
			formats: { columnName: 'Format', cellKey: 'formats' },
			value: { columnName: 'Value', cellKey: 'value' },
			comment: { columnName: 'Comment', cellKey: 'comment' },
		} as IStringFilter,
	],
	[
		'enumFilters',
		{
			...performanceFilters.enumFilters,
			serving_status: {
				columnName: 'Serving Status',
				cellKey: 'serving_status',
				enumOptions: [
					{ value: Statuses.Active, label: 'Active' },
					{ value: Statuses.Paused, label: 'Paused' },
					{ value: Statuses.Ended, label: 'Ended' },
					{ value: Statuses.DealServingStatusUnspecified, label: 'Unspecified' },
					{ value: Statuses.PausedByBuyer, label: 'Paused by Buyer' },
					{ value: Statuses.PausedBySeller, label: 'Paused by Seller' },
				],
				deletable: true,
			},
			deal_type: {
				columnName: 'Deal Type',
				cellKey: 'deal_type',
				enumOptions: [
					{ value: 'OPEN_AUCTION', label: 'Open Auction' },
					{ value: 'PRIVATE_AUCTION', label: 'Private Auction' },
					{ value: 'PREFERRED_DEAL', label: 'Preferred Deal' },
					{ value: 'PROGRAMMATIC_GUARANTEED', label: 'Programmatic Guaranteed' },
				],
				deletable: true,
			},
			deal_resource_type: {
				columnName: 'Deal Resource Type',
				cellKey: 'deal_resource_type',
				enumOptions: [
					{ value: 'NATIVE', label: 'Native' },
					{ value: 'PIXEL', label: 'Pixel' },
					{ value: 'INTERSTITIAL', label: 'Interstitial' },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
	[
		'entityFilters',
		{
			dealIdEntity: {
				columnName: 'Deal ID',
				cellKey: 'deal_id',
				autocompleteCallback: async () => {
					return await CampaignsInputOptionsApi.get().then(inputOptions => {
						return inputOptions.deal_ids
							? inputOptions.deal_ids.map(dealId => ({
									label: dealId,
									value: dealId,
								}))
							: [];
					});
				},
			},
			dealNameEntity: {
				columnName: 'Deal Name',
				cellKey: 'name',
				autocompleteCallback: async () => {
					return await CampaignsInputOptionsApi.get().then(inputOptions => {
						return inputOptions.deal_names.map(name => ({
							label: `${name}`,
							value: name,
						}));
					});
				},
			},
			proposalIdEntity: {
				columnName: 'Proposal Id',
				cellKey: 'proposal_id',
				autocompleteCallback: async () => {
					return await CampaignsInputOptionsApi.get().then(inputOptions => {
						return inputOptions.deal_proposal_ids.map(proposal => ({
							label: `${proposal}`,
							value: proposal,
						}));
					});
				},
			},
			proposalNameEntity: {
				columnName: 'Proposal Name',
				cellKey: 'proposal_name',
				autocompleteCallback: async () => {
					return await CampaignsInputOptionsApi.get().then(inputOptions => {
						return inputOptions.deal_proposal_names.map(proposal => ({
							label: `${proposal}`,
							value: proposal,
						}));
					});
				},
			},
			publisherProfileEntity: {
				columnName: 'Publisher Profile',
				cellKey: 'publisher_profile',
				autocompleteCallback: async () => {
					return await CampaignsInputOptionsApi.get().then(inputOptions => {
						return inputOptions.deal_publisher_profiles.map(publisherProfile => ({
							label: `${publisherProfile}`,
							value: publisherProfile,
						}));
					});
				},
			},
		} as IEntityFilter,
	],
]);
